import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'app/services/app-config/app-config.service';

@Component({
  selector: 'app-lang-dropdown',
  templateUrl: './lang-dropdown.component.html',
  styleUrls: ['./lang-dropdown.component.scss']
})
export class LangDropdownComponent implements OnInit {

  private language: string;

  constructor(
    private appConfigService: AppConfigService
   ) { }

  ngOnInit() {
    this.language = this.appConfigService.getLanguage();
  }

  handleChangeLanguage(languageCode: string) {
    this.appConfigService.setLanguage(languageCode);
    this.language = languageCode;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/lang-dropdown/lang-dropdown.component.ts